import { get } from 'helpers/api';

export const SET_FIELDS = 'SET_FIELDS';
export function setFields(fields) {
  return {
    type: SET_FIELDS,
    fields,
  };
}

export function loadFields(path = null) {
  return async (dispatch, getState) => {
    const fields = await get(path || getState().paths.fields);
    dispatch(setFields(fields));
  };
}
